import script from "./UserInfoBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserInfoBar.vue?vue&type=script&setup=true&lang=ts"

import "./UserInfoBar.vue?vue&type=style&index=0&id=7a4dba44&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a4dba44"]])

export default __exports__